import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { MaintenanceOrder } from 'src/app/models/maintenance-order';
import { MaintenanceOrderService } from 'src/app/services/maintenance-order.service';
import { AuthService } from 'src/app/services/auth.service';
import { ToastrManager } from 'ng6-toastr-notifications';

@Component({
  selector: 'app-maintenance-order-card',
  templateUrl: './maintenance-order-card.component.html',
  styleUrls: ['./maintenance-order-card.component.css']
})
export class MaintenanceOrderCardComponent implements OnInit {
  @Input() order:MaintenanceOrder;
  isWorkshop:boolean = false;
  loading:boolean = false;
  @Output() selected:EventEmitter<MaintenanceOrder> = new EventEmitter();

  constructor(private deleOrder:MaintenanceOrderService, private auth:AuthService, private toastr: ToastrManager) { }

  ngOnInit() {
    this.isWorkshop = this.auth.is('workshop');
  }

  async deleteOrder(){
    try{
      await this.deleOrder.deleteOrder(this.order);
      this.order.status = 'Cerrada';
      this.toastr.successToastr('Orden Cerrada');
    }catch
    {
      this.toastr.errorToastr('Error al eliminar');
    }
  }

  seeStatus() {
    this.selected.emit(this.order);
  }
}
